import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Paper, Link } from "@mui/material";

export default function PrivacyPolicy(props: any) {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const settings = useSelector(state => state.settingsdata.settings);

    const appName = settings?.appName;
    const legalEntity = settings?.CompanyName;

    useEffect(() => {
        document.title = t('privacy_policy');
    }, [t]);

    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 2 }}>
                    <Box sx={{ direction: isRTL ? 'rtl' : 'ltr' }}>
                        <Typography
                            variant="h4"
                            component="h1"
                            gutterBottom
                            sx={{
                                fontWeight: 'bold',
                                mb: 3,
                                textAlign: isRTL ? 'right' : 'left'
                            }}
                        >
                            {t('privacy_policy')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_para1', { appName, legalEntity })}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_para2')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_para3')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_info')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_info_para1')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('location_collection_heading')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('location_collection_para1')}
                        </Typography>

                        <Box component="ul" sx={{
                            mb: 2,
                            pl: isRTL ? 4 : 4,
                            textAlign: isRTL ? 'right' : 'left'
                        }}>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('location_collection_list1')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('location_collection_list2')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('location_collection_list3')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('location_collection_list4')}
                            </Typography>
                        </Box>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('location_collection_para2')}
                        </Typography>

                        <Box component="ul" sx={{
                            mb: 2,
                            pl: isRTL ? 4 : 4,
                            textAlign: isRTL ? 'right' : 'left'
                        }}>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list1')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list2')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list3')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list4')}
                            </Typography>
                        </Box>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_info_para2')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_info_para3')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_info_para4')}
                        </Typography>

                        <Box component="ul" sx={{
                            mb: 2,
                            pl: isRTL ? 4 : 4,
                            textAlign: isRTL ? 'right' : 'left'
                        }}>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list5')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list6')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_info_list7')}
                            </Typography>
                        </Box>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_info_para5')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_log')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_log_para1')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_cookie')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_cookie_para1')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_cookie_para2')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_service')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_service_para1')}
                        </Typography>

                        <Box component="ul" sx={{
                            mb: 2,
                            pl: isRTL ? 4 : 4,
                            textAlign: isRTL ? 'right' : 'left'
                        }}>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_service_list1')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_service_list2')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_service_list3')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('privacy_policy_service_list4')}
                            </Typography>
                        </Box>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_service_para2')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_security')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_security_para1')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_link')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_link_para1')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_children')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_children_para1')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('delete_account_lebel').toUpperCase()}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('delete_account_msg')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('delete_account_subheading')}
                        </Typography>

                        <Box component="ul" sx={{
                            mb: 2,
                            pl: isRTL ? 4 : 4,
                            textAlign: isRTL ? 'right' : 'left'
                        }}>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('delete_account_para1')}
                            </Typography>
                            <Typography component="li" sx={{ lineHeight: 1.8, mb: 0.5 }}>
                                {t('delete_account_para2')}
                            </Typography>
                        </Box>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_change_privacy')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_change_privacy_para1')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_change_privacy_para2')}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                textAlign: isRTL ? 'right' : 'left',
                                mt: 2,
                                mb: 1
                            }}
                        >
                            {t('privacy_policy_heading_contact')}
                        </Typography>

                        <Typography
                            variant="body1"
                            paragraph
                            sx={{
                                textAlign: isRTL ? 'right' : 'left',
                                mb: 2,
                                lineHeight: 1.8
                            }}
                        >
                            {t('privacy_policy_contact_para1', { appName })}
                            {settings && settings.contact_email && (
                                <Link
                                    href={"mailto:" + settings.contact_email}
                                    sx={{
                                        fontWeight: 'bold',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    {settings.contact_email}
                                </Link>
                            )}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                mt: 4,
                                pt: 2,
                                borderTop: '1px solid',
                                borderColor: 'divider',
                                textAlign: 'center',
                                fontSize: '0.8rem',
                                color: 'text.secondary'
                            }}
                        >
                            {t('privacy_policy_footer', { appName, legalEntity })}
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}